import { formatDateOption } from '@/helpers/time';
import {
  BannerStatus,
  CartDateDisplayType,
  DateDisplayMode,
  DateRangeDirection,
  DateRangeIcon,
  DeliveryMethodLayout,
  SortOptionsEnum,
} from './enum';

export const optionPerPage = ['5', '10', '15', '20'];

export const optionsDateRangeDirection = [
  { label: 'Vertical', value: DateRangeDirection.Vertical.toString() },
  { label: 'Horizontal', value: DateRangeDirection.Horizontal.toString() },
];

export const optionsDateRangeIcon = [
  { label: DateRangeIcon.Arrow.toString(), value: DateRangeIcon.Arrow.toString() },
  { label: DateRangeIcon.Dash.toString(), value: DateRangeIcon.Dash.toString() },
];

export const optionLayoutDeliveryMethod = [
  {
    value: DeliveryMethodLayout.Card,
    label: 'Card',
  },
  {
    value: DeliveryMethodLayout.Select,
    label: 'Droplist',
  },
];

export const optionBannerPlacement = [
  {
    value: 'products',
    label: 'Product',
  },
  {
    value: 'home',
    label: 'Home',
  },
  {
    value: 'collections',
    label: 'Collection',
  },
  {
    value: 'pages',
    label: 'All pages',
  },
];

export const dateFormat = (locale: string) => [
  {
    label: formatDateOption('MM/DD/YY', locale),
    value: 'MM/DD/YY',
  },
  {
    label: formatDateOption('MM/DD/YYYY', locale),
    value: 'MM/DD/YYYY',
  },
  {
    label: formatDateOption('DD/MM/YY', locale),
    value: 'DD/MM/YY',
  },
  {
    label: formatDateOption('DD/MM', locale),
    value: 'DD/MM',
  },
  {
    label: formatDateOption('DD/MM/YYYY', locale),
    value: 'DD/MM/YYYY',
  },
  {
    label: formatDateOption('DD.MM.YYYY', locale),
    value: 'DD.MM.YYYY',
  },
  {
    label: formatDateOption('YY/MM/DD', locale),
    value: 'YY/MM/DD',
  },
  {
    label: formatDateOption('DD.MM.YY', locale),
    value: 'DD.MM.YY',
  },
  {
    label: formatDateOption('YY.MM.DD', locale),
    value: 'YY.MM.DD',
  },
  {
    label: formatDateOption('YYYY-MM-DD', locale),
    value: 'YYYY-MM-DD',
  },
  {
    label: formatDateOption('DD-MM-YY', locale),
    value: 'DD-MM-YY',
  },
  {
    label: formatDateOption('DD MMM, YY', locale),
    value: 'DD MMM, YY',
  },
  {
    label: formatDateOption('DD MMM, YYYY', locale),
    value: 'DD MMM, YYYY',
  },
  {
    label: formatDateOption('DD MMMM, YYYY', locale),
    value: 'DD MMMM, YYYY',
  },
  {
    label: formatDateOption('Do MMMM YYYY', locale),
    value: 'Do MMMM YYYY',
  },

  {
    label: formatDateOption('MMMM DD', locale),
    value: 'MMMM DD',
  },
  {
    label: formatDateOption('MMM. DD', locale),
    value: 'MMM. DD',
  },
  {
    label: formatDateOption('MMM DD', locale),
    value: 'MMM DD',
  },
  {
    label: formatDateOption('MMM D', locale),
    value: 'MMM D',
  },
  {
    label: formatDateOption('DD MMM', locale),
    value: 'DD MMM',
  },
  {
    label: formatDateOption('DD. MMM', locale),
    value: 'DD. MMM',
  },
  {
    label: formatDateOption('dddd, DD MMMM, YYYY', locale),
    value: 'dddd, DD MMMM, YYYY',
  },
  {
    label: formatDateOption('ddd, MMM DD, YYYY', locale),
    value: 'ddd, MMM DD, YYYY',
  },
  {
    label: formatDateOption('dddd, MMM DD, YYYY', locale),
    value: 'dddd, MMM DD, YYYY',
  },
  {
    label: formatDateOption('dddd, MMMM DD, YYYY', locale),
    value: 'dddd, MMMM DD, YYYY',
  },
  {
    label: formatDateOption('dddd, DD MMMM', locale),
    value: 'dddd, DD MMMM',
  },

  {
    label: formatDateOption('dddd DD MMMM', locale),
    value: 'dddd DD MMMM',
  },
  {
    label: formatDateOption('DD MMMM', locale),
    value: 'DD MMMM',
  },
  {
    label: formatDateOption('ddd, MMMM DD, YYYY', locale),
    value: 'ddd, MMMM DD, YYYY',
  },
  {
    label: formatDateOption('ddd DD MMM', locale),
    value: 'ddd DD MMM',
  },
  {
    label: formatDateOption('ddd', locale),
    value: 'ddd',
  },
  {
    label: formatDateOption('dddd', locale),
    value: 'dddd',
  },
  {
    label: formatDateOption('dddd, MMMM DD', locale),
    value: 'dddd, MMMM DD',
  },
  {
    label: formatDateOption('ddd MMM DD', locale),
    value: 'ddd MMM DD',
  },
  {
    label: formatDateOption('ddd MMM D', locale),
    value: 'ddd MMM D',
  },
  {
    label: formatDateOption('ddd, MMM DD', locale),
    value: 'ddd, MMM DD',
  },
  {
    label: formatDateOption('MMMM Do', locale),
    value: 'MMMM Do',
  },
];

export const dateDisplayMode = [
  {
    label: 'Relative date (today, tomorrow)',
    value: DateDisplayMode.Relative,
  },
  {
    label: 'Exact date',
    value: DateDisplayMode.Absolute,
  },
];

export const optionsCartDateDisplayType = [
  { label: 'Same as Message text', value: CartDateDisplayType.MessageText },
  { label: 'Customize text', value: CartDateDisplayType.CustomizeText },
];

export const optionsSoldOutDisplayType = [
  { label: 'Same as Message text', value: CartDateDisplayType.MessageText },
  { label: 'Customize text', value: CartDateDisplayType.CustomizeText },
];

export const optionLanguage = [
  {
    label: 'Afrikaans',
    value: 'af',
  },
  {
    label: 'Akan',
    value: 'ak',
  },
  {
    label: 'Albanian',
    value: 'sq',
  },
  {
    label: 'Amharic',
    value: 'am',
  },
  {
    label: 'Arabic',
    value: 'ar',
  },
  {
    label: 'Arabic (Kuwait)',
    value: 'ar-kw',
  },
  {
    label: 'Arabic (Morocco)',
    value: 'ar-ma',
  },
  {
    label: 'Arabic (Saudi Arabia)',
    value: 'ar-sa',
  },
  {
    label: 'Armenian',
    value: 'hy',
  },
  {
    label: 'Assamese',
    value: 'as',
  },
  {
    label: 'Azerbaijani',
    value: 'az',
  },
  {
    label: 'Balarusion',
    value: 'be',
  },
  {
    label: 'Bambara',
    value: 'bm',
  },
  {
    label: 'Basque',
    value: 'eu',
  },
  {
    label: 'Bengali',
    value: 'bn',
  },
  {
    label: 'Bosnian',
    value: 'bs',
  },
  {
    label: 'Breton',
    value: 'br',
  },
  {
    label: 'Bulgarian',
    value: 'bg',
  },
  {
    label: 'Burmese',
    value: 'my',
  },
  {
    label: 'Cambodian',
    value: 'km',
  },
  {
    label: 'Catalan',
    value: 'ca',
  },
  {
    label: 'Central Atlas Tamazight',
    value: 'tzm',
  },
  {
    label: 'Central Kurdish',
    value: 'ckb',
  },
  {
    label: 'Chechen',
    value: 'ce',
  },
  {
    label: 'Chinese (China)',
    value: 'zh-cn',
  },
  {
    label: 'Chinese (Hong Kong)',
    value: 'zh-hk',
  },
  {
    label: 'Chinese (Taiwan)',
    value: 'zh-tw',
  },
  {
    label: 'Cornish',
    value: 'kw',
  },
  {
    label: 'Croatian',
    value: 'hr',
  },
  {
    label: 'Czech',
    value: 'cs',
  },
  {
    label: 'Danish',
    value: 'da',
  },
  {
    label: 'Dutch',
    value: 'nl',
  },
  {
    label: 'Dutch (Belgium)',
    value: 'nl-be',
  },
  {
    label: 'Dzongkha',
    value: 'dz',
  },
  {
    label: 'English (Australia)',
    value: 'en-au',
  },
  {
    label: 'English (Canada)',
    value: 'en-ca',
  },
  {
    label: 'English (Ireland)',
    value: 'en-ie',
  },
  {
    label: 'English (New Zealand)',
    value: 'en-nz',
  },
  {
    label: 'English (United Kingdom)',
    value: 'en-gb',
  },
  {
    label: 'English (United States)',
    value: 'en',
  },
  {
    label: 'Esperanto',
    value: 'eo',
  },
  {
    label: 'Estonian',
    value: 'et',
  },
  {
    label: 'Ewe',
    value: 'ee',
  },
  {
    label: 'Faroese',
    value: 'fo',
  },
  {
    label: 'Filipino',
    value: 'fil',
  },
  {
    label: 'Finnish',
    value: 'fi',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'French (Canada)',
    value: 'fr-ca',
  },
  {
    label: 'French (Switzerland)',
    value: 'fr-ch',
  },
  {
    label: 'Frisian',
    value: 'fy',
  },
  {
    label: 'Fulah',
    value: 'ff',
  },
  {
    label: 'Galician',
    value: 'gl',
  },
  {
    label: 'Ganda',
    value: 'lg',
  },
  {
    label: 'Georgian',
    value: 'ka',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'German (Austria)',
    value: 'de-at',
  },
  {
    label: 'German (Switzerland)',
    value: 'de-ch',
  },
  {
    label: 'Greek',
    value: 'el',
  },
  {
    label: 'Gujarati',
    value: 'gu',
  },
  {
    label: 'Hausa',
    value: 'ha',
  },
  {
    label: 'Hebrew',
    value: 'he',
  },
  {
    label: 'Hindi',
    value: 'hi',
  },
  {
    label: 'Hungarian',
    value: 'hu',
  },
  {
    label: 'Icelandic',
    value: 'is',
  },
  {
    label: 'Igbo',
    value: 'ig',
  },
  {
    label: 'Indonesian',
    value: 'id',
  },
  {
    label: 'Interlingua',
    value: 'ia',
  },
  {
    label: 'Irsh or Irish Gaelic',
    value: 'ga',
  },
  {
    label: 'Italian',
    value: 'it',
  },
  {
    label: 'Italian (Switzerland)',
    value: 'it-ch',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
  {
    label: 'Javanese',
    value: 'jv',
  },
  {
    label: 'Kalaallisut',
    value: 'kl',
  },
  {
    label: 'Kannada',
    value: 'kn',
  },
  {
    label: 'Kashmiri',
    value: 'ks',
  },
  {
    label: 'Kazakh',
    value: 'kk',
  },
  {
    label: 'Kikuyu',
    value: 'ki',
  },
  {
    label: 'Kinyarwanda',
    value: 'rw',
  },
  {
    label: 'Korean',
    value: 'ko',
  },
  {
    label: 'Kurdish',
    value: 'ku',
  },
  {
    label: 'Kyrgyz',
    value: 'ky',
  },
  {
    label: 'Lao',
    value: 'lo',
  },
  {
    label: 'Latvian',
    value: 'lv',
  },
  {
    label: 'Lingala',
    value: 'ln',
  },
  {
    label: 'Lithuanian',
    value: 'lt',
  },
  {
    label: 'Luba-Katanga',
    value: 'lu',
  },
  {
    label: 'Luxembourgish',
    value: 'lb',
  },
  {
    label: 'Macedonian',
    value: 'mk',
  },
  {
    label: 'Malagasy',
    value: 'mg',
  },
  {
    label: 'Malay',
    value: 'ms',
  },
  {
    label: 'Malayalam',
    value: 'ml',
  },
  {
    label: 'Maltese (Malta)',
    value: 'mt',
  },
  {
    label: 'Manx',
    value: 'gv',
  },
  {
    label: 'Maori',
    value: 'mi',
  },
  {
    label: 'Marathi',
    value: 'mr',
  },
  {
    label: 'Mongolian',
    value: 'mn',
  },
  {
    label: 'Nepalese',
    value: 'ne',
  },
  {
    label: 'North Ndebele',
    value: 'nd',
  },
  {
    label: 'Northern Sami',
    value: 'se',
  },
  {
    label: 'Norwegian',
    value: 'no',
  },
  {
    label: 'Norwegian BokmÃ¥l',
    value: 'nb',
  },
  {
    label: 'Nynorsk',
    value: 'nn',
  },
  {
    label: 'Odia',
    value: 'or',
  },
  {
    label: 'Oromo',
    value: 'om',
  },
  {
    label: 'Ossetic',
    value: 'os',
  },
  {
    label: 'Pashto',
    value: 'ps',
  },
  {
    label: 'Persian',
    value: 'fa',
  },
  {
    label: 'Polish',
    value: 'pl',
  },
  {
    label: 'Portuguese',
    value: 'pt',
  },
  {
    label: 'Portuguese (Brazil)',
    value: 'pt-br',
  },
  {
    label: 'Portuguese (Portugal)',
    value: 'pt-PT',
  },
  {
    label: 'Punjabi',
    value: 'pa',
  },
  {
    label: 'Quechua',
    value: 'qu',
  },
  {
    label: 'Romanian',
    value: 'ro',
  },
  {
    label: 'Romansh',
    value: 'rm',
  },
  {
    label: 'Rundi',
    value: 'rn',
  },
  {
    label: 'Russian',
    value: 'ru',
  },
  {
    label: 'Sango',
    value: 'sg',
  },
  {
    label: 'Sanskrit',
    value: 'sa',
  },
  {
    label: 'Sardinian',
    value: 'sc',
  },
  {
    label: 'Scottish Gealic',
    value: 'gd',
  },
  {
    label: 'Serbian',
    value: 'sr',
  },
  {
    label: 'Shona',
    value: 'sn',
  },
  {
    label: 'Sichuan Yi',
    value: 'ii',
  },
  {
    label: 'Sindhi',
    value: 'sd',
  },
  {
    label: 'Sinhalese',
    value: 'si',
  },
  {
    label: 'Slovak',
    value: 'sk',
  },
  {
    label: 'Slovenian',
    value: 'sl',
  },
  {
    label: 'Somali',
    value: 'so',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'Spanish (Dominican Republic)',
    value: 'es-do',
  },
  {
    label: 'Spanish (United States)',
    value: 'es-us',
  },
  {
    label: 'Sundanese',
    value: 'su',
  },
  {
    label: 'Swahili',
    value: 'sw',
  },
  {
    label: 'Swedish',
    value: 'sv',
  },
  {
    label: 'Tajik',
    value: 'tg',
  },
  {
    label: 'Tamil',
    value: 'ta',
  },
  {
    label: 'Tatar',
    value: 'tt',
  },
  {
    label: 'Telugu',
    value: 'te',
  },
  {
    label: 'Thai',
    value: 'th',
  },
  {
    label: 'Tibetan',
    value: 'bo',
  },
  {
    label: 'Tigrinya',
    value: 'ti',
  },
  {
    label: 'Tongan',
    value: 'to',
  },
  {
    label: 'Turkish',
    value: 'tr',
  },
  {
    label: 'Turkmen',
    value: 'tk',
  },
  {
    label: 'Ukrainian',
    value: 'uk',
  },
  {
    label: 'Urdu',
    value: 'ur',
  },
  {
    label: 'Uyghur',
    value: 'ug',
  },
  {
    label: 'Uzbek',
    value: 'uz',
  },
  {
    label: 'Vietnamese',
    value: 'vi',
  },
  {
    label: 'Welsh',
    value: 'cy',
  },
  {
    label: 'Wolof',
    value: 'wo',
  },
  {
    label: 'Xhosa',
    value: 'xh',
  },
  {
    label: 'Yiddish',
    value: 'yi',
  },
  {
    label: 'Yoruba Nigeria',
    value: 'yo',
  },
  {
    label: 'Zulu',
    value: 'zu',
  },
];

export const unionCountries = {
  All: 'All',
  NorthAmerica: 'AI,AG,AW,BS,BB,BZ,BM,VG,CA,BQ,KY,CR,CW,DM,DO,SV,GL,GD,GP,GT,HT,HN,JM,MQ,MX,MS,NI,PA,MF,BL,KN,LC,PM,VC,TT,TC,US',
  SouthAmerica: 'AR,BO,BR,CL,CO,EC,FK,GF,GY,PY,PE,GS,SR,UY,VE',
  EU: 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE',
  SEA: 'BN,KH,TL,ID,LA,MY,MM,PH,SG,TH,VN',
  EastAsia: 'CN,JP,MN,KP,KR,TW',
  SouthAsia: 'AF,BD,BT,IN,MV,NP,PK,LK',
  WestAsia: 'BH,CY,GE,IR,IQ,IL,JO,KW,LB,OM,PS,QA,SA,SY,TR,AE,YE',
  AllCountriesInAllRegion:
    'BH,CY,GE,IR,IQ,IL,JO,KW,LB,OM,PS,QA,SA,SY,TR,AE,YE,AF,BD,BT,IN,MV,NP,PK,LK,CN,JP,MN,KP,KR,TW,BN,KH,TL,ID,LA,MY,MM,PH,SG,TH,VN,AI,AG,AW,BS,BB,BZ,BM,VG,CA,BQ,KY,CR,CW,DM,DO,SV,GL,GD,GP,GT,HT,HN,JM,MQ,MX,MS,NI,PA,MF,BL,KN,LC,PM,VC,TT,TC,US,AR,BO,BR,CL,CO,EC,FK,GF,GY,PY,PE,GS,SR,UY,VE,AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,',
};

export const optionTimezone = [
  { label: '(UTC-11:00) Midway Island', value: 'Pacific/Midway' },
  { label: '(UTC-11:00) Samoa', value: 'Pacific/Samoa' },
  { label: '(UTC-10:00) Hawaii', value: 'Pacific/Honolulu' },
  { label: '(UTC-09:00) Alaska', value: 'US/Alaska' },
  { label: '(UTC-08:00) Pacific Time (US &amp; Canada)', value: 'America/Los_Angeles' },
  { label: '(UTC-08:00) Tijuana', value: 'America/Tijuana' },
  { label: '(UTC-07:00) Arizona', value: 'US/Arizona' },
  { label: '(UTC-07:00) Chihuahua/La Paz', value: 'America/Chihuahua' },
  { label: '(UTC-07:00) Mazatlan', value: 'America/Mazatlan' },
  { label: '(UTC-07:00) Mountain Time (US &amp; Canada)', value: 'US/Mountain' },
  { label: '(UTC-06:00) Central America', value: 'America/Managua' },
  { label: '(UTC-06:00) Central Time (US &amp; Canada)', value: 'US/Central' },
  { label: '(UTC-06:00) Guadalajara/Mexico City', value: 'America/Mexico_City' },
  { label: '(UTC-06:00) Monterrey', value: 'America/Monterrey' },
  { label: '(UTC-06:00) Saskatchewan', value: 'Canada/Saskatchewan' },
  { label: '(UTC-05:00) Bogota/Quito', value: 'America/Bogota' },
  { label: '(UTC-05:00) Eastern Time (US &amp; Canada)', value: 'US/Eastern' },
  { label: '(UTC-05:00) Indiana (East)', value: 'US/East-Indiana' },
  { label: '(UTC-05:00) Lima', value: 'America/Lima' },
  { label: '(UTC-04:00) Atlantic Time (Canada)', value: 'Canada/Atlantic' },
  { label: '(UTC-04:30) Caracas', value: 'America/Caracas' },
  { label: '(UTC-04:00) La Paz', value: 'America/La_Paz' },
  { label: '(UTC-04:00) Santiago', value: 'America/Santiago' },
  { label: '(UTC-03:30) Newfoundland', value: 'Canada/Newfoundland' },
  { label: '(UTC-03:00) Brasilia', value: 'America/Sao_Paulo' },
  { label: '(UTC-03:00) Buenos Aires/Georgetown', value: 'America/Argentina/Buenos_Aires' },
  { label: '(UTC-03:00) Greenland', value: 'America/Godthab' },
  { label: '(UTC-02:00) Mid-Atlantic', value: 'America/Noronha' },
  { label: '(UTC-01:00) Azores', value: 'Atlantic/Azores' },
  { label: '(UTC-01:00) Cape Verde Is.', value: 'Atlantic/Cape_Verde' },
  { label: '(UTC+00:00) Casablanca', value: 'Africa/Casablanca' },
  { label: '(UTC+00:00) London/Edinburgh', value: 'Europe/London' },
  { label: '(UTC+00:00) Greenwich Mean Time : Dublin', value: 'Etc/Greenwich' },
  { label: '(UTC+00:00) Lisbon', value: 'Europe/Lisbon' },
  { label: '(UTC+00:00) Monrovia', value: 'Africa/Monrovia' },
  { label: '(UTC+00:00) UTC', value: 'UTC' },
  { label: '(UTC+01:00) Amsterdam', value: 'Europe/Amsterdam' },
  { label: '(UTC+01:00) Belgrade', value: 'Europe/Belgrade' },
  { label: '(UTC+01:00) Berlin/Bern', value: 'Europe/Berlin' },
  { label: '(UTC+01:00) Bratislava', value: 'Europe/Bratislava' },
  { label: '(UTC+01:00) Brussels', value: 'Europe/Brussels' },
  { label: '(UTC+01:00) Budapest', value: 'Europe/Budapest' },
  { label: '(UTC+01:00) Copenhagen', value: 'Europe/Copenhagen' },
  { label: '(UTC+01:00) Ljubljana', value: 'Europe/Ljubljana' },
  { label: '(UTC+01:00) Madrid', value: 'Europe/Madrid' },
  { label: '(UTC+01:00) Paris', value: 'Europe/Paris' },
  { label: '(UTC+01:00) Prague', value: 'Europe/Prague' },
  { label: '(UTC+01:00) Rome', value: 'Europe/Rome' },
  { label: '(UTC+01:00) Sarajevo', value: 'Europe/Sarajevo' },
  { label: '(UTC+01:00) Skopje', value: 'Europe/Skopje' },
  { label: '(UTC+01:00) Stockholm', value: 'Europe/Stockholm' },
  { label: '(UTC+01:00) Vienna', value: 'Europe/Vienna' },
  { label: '(UTC+01:00) Warsaw', value: 'Europe/Warsaw' },
  { label: '(UTC+01:00) West Central Africa', value: 'Africa/Lagos' },
  { label: '(UTC+01:00) Zagreb', value: 'Europe/Zagreb' },
  { label: '(UTC+02:00) Athens', value: 'Europe/Athens' },
  { label: '(UTC+02:00) Bucharest', value: 'Europe/Bucharest' },
  { label: '(UTC+02:00) Cairo', value: 'Africa/Cairo' },
  { label: '(UTC+02:00) Harare', value: 'Africa/Harare' },
  { label: '(UTC+02:00) Helsinki/Kyiv', value: 'Europe/Helsinki' },
  { label: '(UTC+02:00) Istanbul', value: 'Europe/Istanbul' },
  { label: '(UTC+02:00) Jerusalem', value: 'Asia/Jerusalem' },
  { label: '(UTC+02:00) Pretoria', value: 'Africa/Johannesburg' },
  { label: '(UTC+02:00) Riga', value: 'Europe/Riga' },
  { label: '(UTC+02:00) Sofia', value: 'Europe/Sofia' },
  { label: '(UTC+02:00) Tallinn', value: 'Europe/Tallinn' },
  { label: '(UTC+02:00) Vilnius', value: 'Europe/Vilnius' },
  { label: '(UTC+03:00) Baghdad', value: 'Asia/Baghdad' },
  { label: '(UTC+03:00) Kuwait', value: 'Asia/Kuwait' },
  { label: '(UTC+03:00) Minsk', value: 'Europe/Minsk' },
  { label: '(UTC+03:00) Nairobi', value: 'Africa/Nairobi' },
  { label: '(UTC+03:00) Riyadh', value: 'Asia/Riyadh' },
  { label: '(UTC+03:00) Volgograd', value: 'Europe/Volgograd' },
  { label: '(UTC+03:30) Tehran', value: 'Asia/Tehran' },
  { label: '(UTC+04:00) Abu Dhabi/Muscat', value: 'Asia/Muscat' },
  { label: '(UTC+04:00) Baku', value: 'Asia/Baku' },
  { label: '(UTC+04:00) Moscow/St. Petersburg', value: 'Europe/Moscow' },
  { label: '(UTC+04:00) Tbilisi', value: 'Asia/Tbilisi' },
  { label: '(UTC+04:00) Yerevan', value: 'Asia/Yerevan' },
  { label: '(UTC+04:30) Kabul', value: 'Asia/Kabul' },
  { label: '(UTC+05:00) Karachi/Islamabad', value: 'Asia/Karachi' },
  { label: '(UTC+05:00) Tashkent', value: 'Asia/Tashkent' },
  { label: '(UTC+05:30) Chennai/Mumbai/New Delhi/Sri Jayawardenepura', value: 'Asia/Calcutta' },
  { label: '(UTC+05:30) Kolkata', value: 'Asia/Kolkata' },
  { label: '(UTC+05:45) Kathmandu', value: 'Asia/Katmandu' },
  { label: '(UTC+06:00) Almaty', value: 'Asia/Almaty' },
  { label: '(UTC+06:00) Dhaka/Astana', value: 'Asia/Dhaka' },
  { label: '(UTC+06:00) Ekaterinburg', value: 'Asia/Yekaterinburg' },
  { label: '(UTC+06:30) Rangoon', value: 'Asia/Rangoon' },
  { label: '(UTC+07:00) Bangkok/Hanoi', value: 'Asia/Bangkok' },
  { label: '(UTC+07:00) Jakarta', value: 'Asia/Jakarta' },
  { label: '(UTC+07:00) Novosibirsk', value: 'Asia/Novosibirsk' },
  { label: '(UTC+08:00) Hong Kong/Beijing', value: 'Asia/Hong_Kong' },
  { label: '(UTC+08:00) Chongqing', value: 'Asia/Chongqing' },
  { label: '(UTC+08:00) Krasnoyarsk', value: 'Asia/Krasnoyarsk' },
  { label: '(UTC+08:00) Kuala Lumpur', value: 'Asia/Kuala_Lumpur' },
  { label: '(UTC+08:00) Perth', value: 'Australia/Perth' },
  { label: '(UTC+08:00) Singapore', value: 'Asia/Singapore' },
  { label: '(UTC+08:00) Taipei', value: 'Asia/Taipei' },
  { label: '(UTC+08:00) Ulaan Bataar', value: 'Asia/Ulan_Bator' },
  { label: '(UTC+08:00) Urumqi', value: 'Asia/Urumqi' },
  { label: '(UTC+09:00) Irkutsk', value: 'Asia/Irkutsk' },
  { label: '(UTC+09:00) Tokyo/Osaka/Sapporo', value: 'Asia/Tokyo' },
  { label: '(UTC+09:00) Seoul', value: 'Asia/Seoul' },
  { label: '(UTC+09:30) Adelaide', value: 'Australia/Adelaide' },
  { label: '(UTC+09:30) Darwin', value: 'Australia/Darwin' },
  { label: '(UTC+10:00) Brisbane', value: 'Australia/Brisbane' },
  { label: '(UTC+10:00) Canberra', value: 'Australia/Canberra' },
  { label: '(UTC+10:00) Guam', value: 'Pacific/Guam' },
  { label: '(UTC+10:00) Hobart', value: 'Australia/Hobart' },
  { label: '(UTC+10:00) Melbourne', value: 'Australia/Melbourne' },
  { label: '(UTC+10:00) Port Moresby', value: 'Pacific/Port_Moresby' },
  { label: '(UTC+10:00) Sydney', value: 'Australia/Sydney' },
  { label: '(UTC+10:00) Yakutsk', value: 'Asia/Yakutsk' },
  { label: '(UTC+11:00) Vladivostok', value: 'Asia/Vladivostok' },
  { label: '(UTC+12:00) Auckland/Wellington', value: 'Pacific/Auckland' },
  { label: '(UTC+12:00) Fiji/Marshall Is.', value: 'Pacific/Fiji' },
  { label: '(UTC+12:00) International Date Line West', value: 'Pacific/Kwajalein' },
  { label: '(UTC+12:00) Kamchatka', value: 'Asia/Kamchatka' },
  { label: '(UTC+12:00) Magadan/New CaledoniaSolomon Is.', value: 'Asia/Magadan' },
  { label: '(UTC+13:00) Nuku', value: 'Pacific/Tongatapu' },
];

export const googleCountryOptions = [
  { value: 'ad', label: 'Andorra' },
  { value: 'ae', label: 'United Arab Emirates' },
  { value: 'af', label: 'Afghanistan' },
  { value: 'ag', label: 'Antigua and Barbuda' },
  { value: 'ai', label: 'Anguilla' },
  { value: 'al', label: 'Albania' },
  { value: 'am', label: 'Armenia' },
  { value: 'ao', label: 'Angola' },
  { value: 'ar', label: 'Argentina' },
  { value: 'as', label: 'American Samoa' },
  { value: 'at', label: 'Austria' },
  { value: 'au', label: 'Australia' },
  { value: 'aw', label: 'Aruba' },
  { value: 'az', label: 'Azerbaijan' },
  { value: 'ba', label: 'Bosnia and Herzegovina' },
  { value: 'bb', label: 'Barbados' },
  { value: 'bd', label: 'Bangladesh' },
  { value: 'be', label: 'Belgium' },
  { value: 'bf', label: 'Burkina Faso' },
  { value: 'bg', label: 'Bulgaria' },
  { value: 'bh', label: 'Bahrain' },
  { value: 'bi', label: 'Burundi' },
  { value: 'bj', label: 'Benin' },
  { value: 'bl', label: 'Saint Barthélemy' },
  { value: 'bm', label: 'Bermuda' },
  { value: 'bn', label: 'Brunei' },
  { value: 'bo', label: 'Bolivia' },
  { value: 'br', label: 'Brazil' },
  { value: 'bs', label: 'Bahamas' },
  { value: 'bt', label: 'Bhutan' },
  { value: 'bw', label: 'Botswana' },
  { value: 'by', label: 'Belarus' },
  { value: 'bz', label: 'Belize' },
  { value: 'ca', label: 'Canada' },
  { value: 'cd', label: 'Democratic Republic of the Congo' },
  { value: 'cf', label: 'Central African Republic' },
  { value: 'cg', label: 'Republic of the Congo' },
  { value: 'ch', label: 'Switzerland' },
  { value: 'ci', label: 'Ivory Coast' },
  { value: 'ck', label: 'Cook Islands' },
  { value: 'cl', label: 'Chile' },
  { value: 'cm', label: 'Cameroon' },
  { value: 'cn', label: 'China' },
  { value: 'co', label: 'Colombia' },
  { value: 'cr', label: 'Costa Rica' },
  { value: 'cu', label: 'Cuba' },
  { value: 'cv', label: 'Cape Verde' },
  { value: 'cw', label: 'Curaçao' },
  { value: 'cy', label: 'Cyprus' },
  { value: 'cz', label: 'Czech Republic' },
  { value: 'de', label: 'Germany' },
  { value: 'dj', label: 'Djibouti' },
  { value: 'dk', label: 'Denmark' },
  { value: 'dm', label: 'Dominica' },
  { value: 'do', label: 'Dominican Republic' },
  { value: 'dz', label: 'Algeria' },
  { value: 'ec', label: 'Ecuador' },
  { value: 'ee', label: 'Estonia' },
  { value: 'eg', label: 'Egypt' },
  { value: 'er', label: 'Eritrea' },
  { value: 'es', label: 'Spain' },
  { value: 'et', label: 'Ethiopia' },
  { value: 'fi', label: 'Finland' },
  { value: 'fj', label: 'Fiji' },
  { value: 'fk', label: 'Falkland Islands' },
  { value: 'fm', label: 'Micronesia' },
  { value: 'fo', label: 'Faroe Islands' },
  { value: 'fr', label: 'France' },
  { value: 'ga', label: 'Gabon' },
  { value: 'gb', label: 'United Kingdom' },
  { value: 'gd', label: 'Grenada' },
  { value: 'ge', label: 'Georgia' },
  { value: 'gf', label: 'French Guiana' },
  { value: 'gg', label: 'Guernsey' },
  { value: 'gh', label: 'Ghana' },
  { value: 'gi', label: 'Gibraltar' },
  { value: 'gl', label: 'Greenland' },
  { value: 'gm', label: 'Gambia' },
  { value: 'gn', label: 'Guinea' },
  { value: 'gp', label: 'Guadeloupe' },
  { value: 'gq', label: 'Equatorial Guinea' },
  { value: 'gr', label: 'Greece' },
  { value: 'gt', label: 'Guatemala' },
  { value: 'gu', label: 'Guam' },
  { value: 'gw', label: 'Guinea-Bissau' },
  { value: 'gy', label: 'Guyana' },
  { value: 'hk', label: 'Hong Kong' },
  { value: 'hn', label: 'Honduras' },
  { value: 'hr', label: 'Croatia' },
  { value: 'ht', label: 'Haiti' },
  { value: 'hu', label: 'Hungary' },
  { value: 'id', label: 'Indonesia' },
  { value: 'ie', label: 'Ireland' },
  { value: 'il', label: 'Israel' },
  { value: 'im', label: 'Isle of Man' },
  { value: 'in', label: 'India' },
  { value: 'iq', label: 'Iraq' },
  { value: 'ir', label: 'Iran' },
  { value: 'is', label: 'Iceland' },
  { value: 'it', label: 'Italy' },
  { value: 'je', label: 'Jersey' },
  { value: 'jm', label: 'Jamaica' },
  { value: 'jo', label: 'Jordan' },
  { value: 'jp', label: 'Japan' },
  { value: 'ke', label: 'Kenya' },
  { value: 'kg', label: 'Kyrgyzstan' },
  { value: 'kh', label: 'Cambodia' },
  { value: 'ki', label: 'Kiribati' },
  { value: 'km', label: 'Comoros' },
  { value: 'kn', label: 'Saint Kitts and Nevis' },
  { value: 'kp', label: 'North Korea' },
  { value: 'kr', label: 'South Korea' },
  { value: 'kw', label: 'Kuwait' },
  { value: 'ky', label: 'Cayman Islands' },
  { value: 'kz', label: 'Kazakhstan' },
  { value: 'la', label: 'Laos' },
  { value: 'lb', label: 'Lebanon' },
  { value: 'lc', label: 'Saint Lucia' },
  { value: 'li', label: 'Liechtenstein' },
  { value: 'lk', label: 'Sri Lanka' },
  { value: 'lr', label: 'Liberia' },
  { value: 'ls', label: 'Lesotho' },
  { value: 'lt', label: 'Lithuania' },
  { value: 'lu', label: 'Luxembourg' },
  { value: 'lv', label: 'Latvia' },
  { value: 'ly', label: 'Libya' },
  { value: 'ma', label: 'Morocco' },
  { value: 'mc', label: 'Monaco' },
  { value: 'md', label: 'Moldova' },
  { value: 'me', label: 'Montenegro' },
  { value: 'mf', label: 'Saint Martin' },
  { value: 'mg', label: 'Madagascar' },
  { value: 'mh', label: 'Marshall Islands' },
  { value: 'mk', label: 'North Macedonia' },
  { value: 'ml', label: 'Mali' },
  { value: 'mm', label: 'Myanmar' },
  { value: 'mn', label: 'Mongolia' },
  { value: 'mo', label: 'Macau' },
  { value: 'mp', label: 'Northern Mariana Islands' },
  { value: 'mq', label: 'Martinique' },
  { value: 'mr', label: 'Mauritania' },
  { value: 'ms', label: 'Montserrat' },
  { value: 'mt', label: 'Malta' },
  { value: 'mu', label: 'Mauritius' },
  { value: 'mv', label: 'Maldives' },
  { value: 'mw', label: 'Malawi' },
  { value: 'mx', label: 'Mexico' },
  { value: 'my', label: 'Malaysia' },
  { value: 'mz', label: 'Mozambique' },
  { value: 'na', label: 'Namibia' },
  { value: 'nc', label: 'New Caledonia' },
  { value: 'ne', label: 'Niger' },
  { value: 'ng', label: 'Nigeria' },
  { value: 'ni', label: 'Nicaragua' },
  { value: 'nl', label: 'Netherlands' },
  { value: 'no', label: 'Norway' },
  { value: 'np', label: 'Nepal' },
  { value: 'nr', label: 'Nauru' },
  { value: 'nz', label: 'New Zealand' },
  { value: 'om', label: 'Oman' },
  { value: 'pa', label: 'Panama' },
  { value: 'pe', label: 'Peru' },
  { value: 'pf', label: 'French Polynesia' },
  { value: 'pg', label: 'Papua New Guinea' },
  { value: 'ph', label: 'Philippines' },
  { value: 'pk', label: 'Pakistan' },
  { value: 'pl', label: 'Poland' },
  { value: 'pm', label: 'Saint Pierre and Miquelon' },
  { value: 'pr', label: 'Puerto Rico' },
  { value: 'pt', label: 'Portugal' },
  { value: 'pw', label: 'Palau' },
  { value: 'py', label: 'Paraguay' },
  { value: 'qa', label: 'Qatar' },
  { value: 're', label: 'Réunion' },
  { value: 'ro', label: 'Romania' },
  { value: 'rs', label: 'Serbia' },
  { value: 'ru', label: 'Russia' },
  { value: 'rw', label: 'Rwanda' },
  { value: 'sa', label: 'Saudi Arabia' },
  { value: 'sb', label: 'Solomon Islands' },
  { value: 'sc', label: 'Seychelles' },
  { value: 'sd', label: 'Sudan' },
  { value: 'se', label: 'Sweden' },
  { value: 'sg', label: 'Singapore' },
  { value: 'sh', label: 'Saint Helena' },
  { value: 'si', label: 'Slovenia' },
  { value: 'sk', label: 'Slovakia' },
  { value: 'sl', label: 'Sierra Leone' },
  { value: 'sm', label: 'San Marino' },
  { value: 'sn', label: 'Senegal' },
  { value: 'so', label: 'Somalia' },
  { value: 'sr', label: 'Suriname' },
  { value: 'ss', label: 'South Sudan' },
  { value: 'st', label: 'São Tomé and Príncipe' },
  { value: 'sv', label: 'El Salvador' },
  { value: 'sx', label: 'Sint Maarten' },
  { value: 'sy', label: 'Syria' },
  { value: 'sz', label: 'Eswatini' },
  { value: 'tc', label: 'Turks and Caicos Islands' },
  { value: 'td', label: 'Chad' },
  { value: 'tg', label: 'Togo' },
  { value: 'th', label: 'Thailand' },
  { value: 'tj', label: 'Tajikistan' },
  { value: 'tl', label: 'Timor-Leste' },
  { value: 'tm', label: 'Turkmenistan' },
  { value: 'tn', label: 'Tunisia' },
  { value: 'to', label: 'Tonga' },
  { value: 'tr', label: 'Turkey' },
  { value: 'tt', label: 'Trinidad and Tobago' },
  { value: 'tv', label: 'Tuvalu' },
  { value: 'tw', label: 'Taiwan' },
  { value: 'tz', label: 'Tanzania' },
  { value: 'ua', label: 'Ukraine' },
  { value: 'ug', label: 'Uganda' },
  { value: 'us', label: 'United States' },
  { value: 'uy', label: 'Uruguay' },
  { value: 'uz', label: 'Uzbekistan' },
  { value: 'va', label: 'Vatican City' },
  { value: 'vc', label: 'Saint Vincent and the Grenadines' },
  { value: 've', label: 'Venezuela' },
  { value: 'vg', label: 'British Virgin Islands' },
  { value: 'vi', label: 'U.S. Virgin Islands' },
  { value: 'vn', label: 'Vietnam' },
  { value: 'vu', label: 'Vanuatu' },
  { value: 'wf', label: 'Wallis and Futuna' },
  { value: 'ws', label: 'Samoa' },
  { value: 'xk', label: 'Kosovo' },
  { value: 'ye', label: 'Yemen' },
  { value: 'yt', label: 'Mayotte' },
  { value: 'za', label: 'South Africa' },
  { value: 'zm', label: 'Zambia' },
  { value: 'zw', label: 'Zimbabwe' },
];

export const bannerStatusCards = [
  {
    value: BannerStatus.info,
    label: 'Info',
    contentColor: '#E3E3E3',
    backgroundColor: '#F5F5F5',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M10.0005 14.7765V10.4749C10.0005 10.396 9.93653 10.332 9.85763 10.332H8.88938M18.0005 10.332C18.0005 14.7503 14.4188 18.332 10.0005 18.332C5.58221 18.332 2.00049 14.7503 2.00049 10.332C2.00049 5.91375 5.58221 2.33203 10.0005 2.33203C14.4188 2.33203 18.0005 5.91375 18.0005 10.332ZM10.5719 6.33203C10.5719 6.64762 10.3161 6.90346 10.0005 6.90346C9.6849 6.90346 9.42906 6.64762 9.42906 6.33203C9.42906 6.01644 9.6849 5.7606 10.0005 5.7606C10.3161 5.7606 10.5719 6.01644 10.5719 6.33203ZM9.99692 6.32846H10.0036V6.3356H9.99692V6.32846Z" stroke="#787878" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    value: BannerStatus.warning,
    label: 'Warning',
    contentColor: '#FFDEB2',
    backgroundColor: '#FFF5EB',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M10 8.33203L10 11.332" stroke="#8F6900" strokeWidth="1.16667" strokeLinecap="round"/>
  <circle cx="10.0001" cy="14.3326" r="0.285714" stroke="#8F6900" strokeWidth="1.16667"/>
  <path d="M10.0032 14.3281H9.99658V14.3353H10.0032V14.3281Z" stroke="#8F6900" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M9.55567 3.16515C9.74525 2.80968 10.2547 2.80968 10.4443 3.16515L17.605 16.5915C17.7839 16.9269 17.5409 17.332 17.1607 17.332H2.83929C2.45913 17.332 2.21606 16.9269 2.39496 16.5915L9.55567 3.16515Z" stroke="#8F6900" strokeWidth="1.16667"/>
</svg>`,
  },
  {
    value: BannerStatus.success,
    label: 'Success',
    contentColor: '#B1F2B4',
    backgroundColor: '#EAFBEA',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M13.5714 7.7606L9.87681 13.321C9.67683 13.622 9.25122 13.6641 8.99613 13.4082L6.42857 10.832M18 10.332C18 14.7503 14.4183 18.332 10 18.332C5.58172 18.332 2 14.7503 2 10.332C2 5.91375 5.58172 2.33203 10 2.33203C14.4183 2.33203 18 5.91375 18 10.332Z" stroke="#4D7A50" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    value: BannerStatus.critical,
    label: 'Critical',
    contentColor: '#FDD8D8',
    backgroundColor: '#FEF6F6',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M10 6.16536L10 10.0543M18 10.332C18 14.7503 14.4183 18.332 10 18.332C5.58172 18.332 2 14.7503 2 10.332C2 5.91375 5.58172 2.33203 10 2.33203C14.4183 2.33203 18 5.91375 18 10.332ZM10.2857 14.332C10.2857 14.4898 10.1578 14.6177 10 14.6177C9.8422 14.6177 9.71429 14.4898 9.71429 14.332C9.71429 14.1742 9.8422 14.0463 10 14.0463C10.1578 14.0463 10.2857 14.1742 10.2857 14.332ZM9.99643 14.3285H10.0031V14.3356H9.99643V14.3285Z" stroke="#DD1D1D" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
];

export const optionsSortBy = [
  {
    value: SortOptionsEnum.IdDesc,
    label: 'Time created (newest) - Default',
  },
  {
    value: SortOptionsEnum.IdAsc,
    label: 'Time created (oldest)',
  },
  {
    value: SortOptionsEnum.NameAsc,
    label: 'Rule name (A-Z)',
  },
  {
    value: SortOptionsEnum.NameDesc,
    label: 'Rule name (Z-A)',
  },
  {
    value: SortOptionsEnum.MinPrepareAsc,
    label: 'Min preparation (ascending)',
  },
  {
    value: SortOptionsEnum.MinPrepareDesc,
    label: 'Min preparation (descending)',
  },
  {
    value: SortOptionsEnum.MaxPrepareAsc,
    label: 'Max preparation (ascending)',
  },
  {
    value: SortOptionsEnum.MaxPrepareDesc,
    label: 'Max preparation (descending)',
  },
  {
    value: SortOptionsEnum.MinDeliveryAsc,
    label: 'Min delivery (ascending)',
  },
  {
    value: SortOptionsEnum.MinDeliveryDesc,
    label: 'Min delivery (descending)',
  },
  {
    value: SortOptionsEnum.MaxDeliveryAsc,
    label: 'Max delivery (ascending)',
  },
  {
    value: SortOptionsEnum.MaxDeliveryDesc,
    label: 'Max delivery (descending)',
  },
];
